import { useState } from "react";

function useDatatablesServerSide({
  defaultLimit = 10,
  defaultPage = 1,
  setNewData,
  additionalProps = null,
}) {
  const [pagination, setPagination] = useState({
    limit: defaultLimit,
    page: defaultPage,
    count: 0,
  });
  const onNext = async () => {
    const currentPage = pagination.page + 1;
    await setNewData(currentPage, pagination.limit);
    setPagination({
      ...pagination,
      page: currentPage,
    });
  };

  const onPrevious = async () => {
    const currentPage = pagination.page - 1;
    await setNewData(currentPage, pagination.limit);
    setPagination({
      ...pagination,
      page: currentPage,
    });
  };

  const handleClickPageNumber = async (page) => {
    await setNewData(page, pagination.limit);
    setPagination({
      ...pagination,
      page,
    });
  };

  const handleChangeLimit = async (e) => {
    setPagination({
      page: 1,
      limit: parseInt(e.target.value),
    });
    await setNewData(1, e.target.value);
  };

  const resetPagination = () => {
    setPagination({
      count: 0,
      limit: defaultLimit,
      page: 1,
    });
  };

  return {
    onNext,
    onPrevious,
    handleChangeLimit,
    handleClickPageNumber,
    pagination,
    setPagination,
    resetPagination,
  };
}

export default useDatatablesServerSide;
